export default "__VITE_ASSET__6aa2DsDn__"